import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectSoftwareRoute: InvariantJiraRoute = {
	name: 'software-issue-navigator',
	// Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
	path: '/jira/software/projects/:projectKey/issues/:issueKey?',
	query: ['selectedIssue?'],
};
